import { render, staticRenderFns } from "./ConfirmSubPage.vue?vue&type=template&id=46838a36&"
import script from "./ConfirmSubPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmSubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports